import { pr, theme, ui } from "aaa";
import { observer } from "mobx-react";
import * as React from "react";
import { pushRoute } from "stores/RouterFunctions";
import { IJuniorDocument } from "types/profile";
import { ContinueButton } from "../components/ContinueButton";
import { DocumentItem } from "../components/DocumentItem";
import { ScreenWithBottomAction } from "../components/ScreenWithBottomAction";
import { JuniorRoutes } from "../JuniorRoutes";
import { JuniorStore } from "../JuniorStore";
import { customColors, themeColors } from "muiTheme";

type IProps = {
    store: JuniorStore;
};

export const JuniorActivateDocuments = observer(({ store }: IProps) => {

    const handleContinue = async () => {
        try {
            await store.activateJunior();
            pushRoute(JuniorRoutes.ACTIVATE_SIGNING);
        } catch (error) {
            pushRoute(JuniorRoutes.ACTIVATE_ERROR);
        }
    };

    const documents = store.contractInfo?.agreements?.[0]?.documents || [];

    React.useEffect(() => {
        if (!store.mainContactEmail || !store.selectedChild) {
            pushRoute(JuniorRoutes.OVERVIEW);
            return;
        }

        store.createJuniorContract(store.mainContactEmail);
    }, [store.mainContactEmail, store.selectedChild]);

    return (
        <ScreenWithBottomAction
            title={ui.__("gJunior.activate.documents.title")}
            ContinueButton={<ContinueButton
                messageId="gJunior.activate.documents.continue"
                onClick={handleContinue}
            />}
            isLoading={store.isLoadingContract}
        >
            <pr.P_16_CONTENT style={{
                marginTop: theme.MARGIN_SMALL,
                color: ui.isDarkMode ? "white" : themeColors.george_text_color
            }}>
                {ui.__("gJunior.activate.documents.description")}
            </pr.P_16_CONTENT>

            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: theme.MARGIN }}>
                {documents.map((document: IJuniorDocument, index: number) => (
                    <DocumentItem key={index} displayName={document.displayName} _links={document._links} store={store} />
                ))}
            </div>

            <pr.P_16_CONTENT style={{
                marginTop: theme.MARGIN_SMALL,
                color: ui.isDarkMode ? "white" : customColors.georgeJuniorSecondary
            }}>
                {ui.__("gJunior.activate.documents.hintText")}
            </pr.P_16_CONTENT>

        </ScreenWithBottomAction>
    );
});


// WEBPACK FOOTER //
// ./src/components/gJunior/activateStep/JuniorActivateDocuments.tsx